"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioGroup = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledRadioGroup = require("./styled-radio-group");
var _excluded = ["children", "className", "dataTestId", "errorMessage", "groupName", "legend", "stacked"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useMemo = _react["default"].useMemo;
var propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  groupName: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  legend: _propTypes["default"].string,
  stacked: _propTypes["default"].bool
};
var defaultProps = {
  className: '',
  dataTestId: '',
  errorMessage: '',
  legend: '',
  stacked: true
};
var RadioGroup = exports.RadioGroup = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    errorMessage = _ref.errorMessage,
    groupName = _ref.groupName,
    legend = _ref.legend,
    stacked = _ref.stacked,
    others = _objectWithoutProperties(_ref, _excluded);
  // Unique IDs
  var alertId = useMemo(function () {
    return (0, _fuseUtils.namedUuid)('fuse-radio-group-alert');
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styledRadioGroup.StyledRadioGroup, _extends({
    className: className,
    "data-testid": dataTestId || 'fuse-radio-group',
    ref: ref
  }, others), !!legend && /*#__PURE__*/_react["default"].createElement(_styledRadioGroup.StyledRadioLegend, {
    size: {
      xxs: 'm1',
      m: '1'
    },
    tag: "legend",
    type: "heading"
  }, legend), !!errorMessage && /*#__PURE__*/_react["default"].createElement(_styledRadioGroup.StyledRadioAlert, {
    id: alertId,
    message: errorMessage,
    role: "alert",
    showIcon: true,
    size: "small",
    variant: "error"
  }), /*#__PURE__*/_react["default"].createElement(_styledRadioGroup.StyledRadioContainer, {
    stacked: stacked
  }, _react["default"].Children.map(children, function (el) {
    return /*#__PURE__*/_react["default"].cloneElement(el, {
      'aria-describedby': errorMessage ? alertId : '',
      'aria-invalid': errorMessage ? true : undefined,
      name: groupName
    });
  })));
});
RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;
var _default = exports["default"] = RadioGroup;